import { Directive, Input, OnChanges, Optional } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";

// ng2-charts v5 removeu o Input `colors`.
// Esse directive mantém compatibilidade com templates antigos:
// <canvas baseChart [colors]="colors" ...>
//
// Também tenta aplicar as cores nos datasets (best-effort) para não quebrar visualmente.
@Directive({
  selector: "canvas[baseChart][colors]",
})
export class Ng2ChartsColorsCompatDirective implements OnChanges {
  @Input() colors: any;

  constructor(@Optional() private baseChart?: BaseChartDirective) {}

  ngOnChanges(): void {
    if (!this.baseChart || !this.colors) return;

    const chart: any = (this.baseChart as any).chart;
    const datasets: any[] =
      chart?.data?.datasets ||
      (this.baseChart as any).datasets ||
      (this.baseChart as any).data?.datasets ||
      [];

    if (!Array.isArray(datasets) || datasets.length === 0) return;

    const colorsArr: any[] = Array.isArray(this.colors) ? this.colors : [];

    // Caso comum (bar/line): 1 cor por dataset
    if (colorsArr.length >= datasets.length) {
      datasets.forEach((ds, i) => this.applyColorObject(ds, colorsArr[i]));
    }

    // Caso comum (pie): 1 dataset com backgroundColor array
    if (datasets.length === 1 && colorsArr.length === 1) {
      this.applyColorObject(datasets[0], colorsArr[0]);
    }

    if (typeof (this.baseChart as any).update === "function") {
      (this.baseChart as any).update();
    }
  }

  private applyColorObject(dataset: any, colorObj: any): void {
    if (!dataset || !colorObj) return;

    const keys = [
      "backgroundColor",
      "borderColor",
      "pointBackgroundColor",
      "pointBorderColor",
      "pointBorderWidth",
      "pointRadius",
      "pointHoverRadius",
      "borderWidth",
      "hoverBackgroundColor",
      "hoverBorderColor",
    ];

    keys.forEach((k) => {
      if (colorObj[k] !== undefined && dataset[k] === undefined) {
        dataset[k] = colorObj[k];
      }
    });
  }
}


